import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class ForestWhispering8PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FOREST_WHISPERING8;
}

export default ForestWhispering8PoiTileEntity;
